import React, {
  useState,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import "../../css/Panel.css";
import "../../css/Patient.css";
import "../../css/PatientSearch.css";
import "../../css/custom-datatable.css";
import "../css/Sales.css";
import "../css/PopupMessage.css";

import NavTableCell from "../components/NavTableCell";
import SaleTableItemIVA from "../components/SaleTableItemIVA";
import PopupTitle from "../components/PopupTitle";
import InputDataCurrency from "../components/InputDataCurrency";
import RoundedUserPic from "../components/RoundedUserPic";
import { transformPatientPicture } from "../utils/patients";
import CartItem from "../components/CartItem";
import ButtonCheck from "../components/ButtonCheck";

import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import InputSearch from "../../components/InputSearch";
import Dropdown from "../../components/Dropdown";
import DropdownFilter from "../../components/DropdownFilter";
import PopupNIFTypes from "../../components/PopupNIFTypes";
import PopupCP from "../components/PopupCP";
import PopupSaleObservations from "../components/PopupSaleObservations";
import PopupInvoicePrintingSimple from "../components/PopupInvoicePrintingSimple";
import PopupPrintingSaleSimple from "../components/PopupPrintingSaleSimple";
import PopupEmail from "../components/PopupEmail";
import ButtonIconV from "../../components/ButtonIconV";
import LoadingScreen from "../../components/LoadingScreen";

import { post as rpost } from "../js/api";
import { post } from "../../js/post";
import {
  formatCurrency,
  createAddress,
  calculatePVU,
  calculateDto,
  calculateIVASuperRed,
  calculateDtoFromAll,
} from "../utils/utils";
import { calculateDtos } from "../../js/calculateDtos";
import { exportToFile } from "../js/exportToFile";
import { newQuote, newSaleLine, newCrossSelling } from "../skels/Sale";

import { userData, selectedOptic, provinceOptions } from "../../js/utils";

import DataTable from "react-data-table-component";
import moment from "moment";

const NUM_PRODUCTS_LIMIT = 20;

export default forwardRef(
  (
    {
      show,
      onClickMenuOption,
      createPopupQuestion,
      removePopupQuestion,
      onGoBack,
      saleId,
      orderCards = [],
      orderPatientId = -1,
    },
    ref,
  ) => {
    const [loaded, setLoaded] = useState(false);
    const [emptySale, setEmptySale] = useState(false);
    const [venta, setVenta] = useState(null);
    const [ventaLinesTable, setVentaLinesTable] = useState([]);
    const [nId, setNId] = useState(-1);
    const [forceCreateNewRow, setForceCreateNewRow] = useState(false);
    const [totalDtoF, setTotalDtoF] = useState("");
    const [totalBaseF, setTotalBaseF] = useState("");
    const [totalIVAF, setTotalIVAF] = useState("");
    const [invoice, setInvoice] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState(null);
    const [cardTypes, setCardTypes] = useState(null);
    const [address, setAddress] = useState(null);
    // Id del input de CP mal formado ("" si no hay error)
    const [errorCP, setErrorCP] = useState("");

    useEffect(() => {
      if (errorCP !== "") {
        createPopupQuestion(
          "Por favor, revise el código postal.",
          () => {
            const el = document.getElementById(errorCP);
            if (el) {
              el.focus();
            }
            setErrorCP("");
            removePopupQuestion();
            return;
          },
          null,
          "Entendido",
        );
      }
    }, [errorCP]);
    const [cartPopup, setCartPopup] = useState(null);
    const [nifTypePopup, setNifTypePopup] = useState("");
    const [showPopupCP, setShowPopupCP] = useState(false);
    const [showObservationsPopup, setShowObservationsPopup] = useState(false);
    const [showProformaPrintingPopup, setShowProformaPrintingPopup] =
      useState(false);
    const [showPrintingSalePopup, setShowPrintingSalePopup] = useState(false);
    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [emailAttachment, setEmailAttachment] = useState(null);
    const [emailDestinatario, setEmailDestinatario] = useState("");
    const [emailAsunto, setEmailAsunto] = useState("");
    const [cpPopupAddress, setCPPopupAddress] = useState("");
    const [cpPopupCity, setCPPopupCity] = useState("");
    const [cpPopupType, setCPPopupType] = useState("personal");
    const [tiposIVA, setTiposIVA] = useState(null);
    const [IVASuperRed, setIVASuperRed] = useState(4);
    const [tiposCrossSelling, setTiposCrossSelling] = useState(null);
    const [opticConfig, setOpticConfig] = useState({
      diasValidezPrePro: 0,
    });

    const [agents, setAgents] = useState(null);
    const [filterRealizadoPor, setFilterRealizadoPor] = useState({
      id: -1,
      text: "",
    });

    const [campaigns, setCampaigns] = useState(null);
    const [filterCampaign, setFilterCampaign] = useState({
      id: -1,
      text: "",
    });

    const [expired, setExpired] = useState(false);

    const [loading, setLoading] = useState(false);

    useImperativeHandle(ref, () => ({
      canChangeScreen: (screen, params) => {
        const canChange =
          saleId === -1 && JSON.stringify(venta) === JSON.stringify(emptySale);
        if (!canChange) {
          onGoToScreen(screen, true);
        }
        return canChange;
      },
    }));

    const printDocumentOptions = useMemo(
      () =>
        venta && venta.id !== -1
          ? [{ id: "imp", text: "Factura proforma (A4)" }]
          : [],
      [venta],
    );

    const ventaColumns = useMemo(
      () => [
        {
          name: "Código",
          width: "9%",
          cell: (row) =>
            row.type === "user-line" ? (
              <div className="sales-table-cart-user">
                <RoundedUserPic
                  width={25}
                  height={25}
                  img={transformPatientPicture(row.pic)}
                />
                <span>{row.patient}</span>
                <img
                  className="sales-table-cart-remove"
                  src="/images/remove-blue.svg"
                  onClick={() => onRemoveCart(row.cartId)}
                />
              </div>
            ) : (
              <NavTableCell
                id={"ntc-" + (row.index + 1) + "-1"}
                value={row.code}
                type=""
                canBeEmpty={true}
                onChange={(value) => {
                  const ventaN = structuredClone(venta);
                  ventaN.lines[row.index].code = value;
                  setVenta(ventaN);
                  const ventaLinesTableN = structuredClone(ventaLinesTable);
                  ventaLinesTableN[row.index].code = value;
                  setVentaLinesTable(ventaLinesTableN);
                }}
                onBlur={() => {
                  let ventaN = structuredClone(venta);
                  ventaN = updateVentasTotal(ventaN);
                  setVenta(ventaN);
                }}
                onNoNextCell={createNewRow}
                onPressEnter={async (value) => {
                  const sourceEl = document.activeElement;
                  const found = await readProduct(value, row.index);
                  if (found && document.activeElement === sourceEl) {
                    setTimeout(() => {
                      const el = document.getElementById(
                        "ntc-" + (row.index + 1) + "-2",
                      );
                      if (el) {
                        el.focus();
                        setTimeout(() => {
                          if (document.activeElement === el) {
                            el.select();
                          }
                        }, 1);
                      }
                    }, 100);
                  }
                }}
                readOnly={
                  row.cardId != -1 || venta.status === "Venta" || expired
                }
                stock={venta.status !== "Venta" && !expired ? row.stock : ""}
              />
            ),
        },
        {
          name: "Descripción del producto",
          width: "40%",
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-2"}
                  value={row.description}
                  type=""
                  canBeEmpty={true}
                  onChange={(value) => {
                    const ventaN = structuredClone(venta);
                    getLineRef(ventaN, row).description = value;
                    setVenta(ventaN);
                    const ventaLinesTableN = structuredClone(ventaLinesTable);
                    ventaLinesTableN[row.index].description = value;
                    setVentaLinesTable(ventaLinesTableN);
                  }}
                  onBlur={() => {
                    let ventaN = structuredClone(venta);
                    ventaN = updateVentasTotal(ventaN);
                    setVenta(ventaN);
                  }}
                  onNoNextCell={createNewRow}
                  showList={true}
                  updateList={getProducts}
                  onSelectOption={(product) =>
                    selectProduct(product, row.index)
                  }
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "PVP",
          width: "8%",
          center: true,
          headerStyle: { textAlign: "center" },
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-3"}
                  value={row.pvp}
                  type="type-currency"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).pvp) {
                      onChangePVPLine(
                        typeof value === "string"
                          ? value.replace(",", ".")
                          : value,
                        row,
                      );
                    }
                  }}
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "Dto.",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-4"}
                  value={Math.round(parseFloat(row.dto) || 0)}
                  type="type-int-perc"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    // El dto de la línea es float, pero la celda muestra el
                    // entero: solo se recalcula si cambia el valor visible.
                    if (
                      value !=
                      Math.round(parseFloat(getLineRef(venta, row).dto) || 0)
                    ) {
                      setTimeout(() => onChangeDtoLine(value, row), 100);
                    }
                  }}
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "IVA",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-5"}
                  value={row.iva}
                  type="type-float-perc"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).iva) {
                      setTimeout(
                        () =>
                          onChangeIVALine(
                            typeof value === "string"
                              ? value.replace(",", ".")
                              : value,
                            row,
                          ),
                        100,
                      );
                    }
                  }}
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "PVU",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-6"}
                  value={row.pvu}
                  type="type-currency"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).pvu) {
                      onChangePVULine(
                        typeof value === "string"
                          ? value.replace(",", ".")
                          : value,
                        row,
                      );
                    }
                  }}
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "Uds.",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-7"}
                  value={row.uds}
                  type="type-only-numbers"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).uds) {
                      onChangeUdsLine(value, row);
                    }
                  }}
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "Total",
          width: venta?.status === "Venta" || expired ? "11%" : "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-8"}
                  value={row.total}
                  type="type-currency"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).total) {
                      onChangeTotalLine(
                        typeof value === "string"
                          ? value.replace(",", ".")
                          : value,
                        row,
                      );
                    }
                  }}
                  readOnly={venta.status === "Venta" || expired}
                  stock={venta.status !== "Venta" && !expired ? row.stock : ""}
                />
              )}
            </div>
          ),
        },
        {
          name: "",
          width: "3%",
          cell: (row) => (
            <div
              className={
                row.type === "user-line"
                  ? "ntc-hide"
                  : "ntc-cell-header" +
                    (row.stock !== "" && row.stock <= 0
                      ? " ntc-cell-header-no-stock"
                      : "")
              }
            >
              {row.type !== "user-line" &&
                row.cardId == -1 &&
                venta.status !== "Venta" &&
                !expired && (
                  <div className="navtable-opt ntc-trash ">
                    <img
                      src="/images/remove-blue.svg"
                      onClick={() => removeLine(row.index)}
                    />
                  </div>
                )}
            </div>
          ),
        },
      ],
      [venta],
    );

    const conditionalRowStyles = [
      {
        when: (row) => row.type === "user-line",
        style: {
          width: "100%",
        },
      },
      {
        when: (row) => row.type === "sale-line" && row.index === 0,
        style: {
          width: "9%",
        },
      },
    ];

    const createVentaLinesTable = (v) => {
      let index = 0;
      const lines = [];

      v.lines.forEach((line) => {
        const row = {
          index,
          type: "sale-line",
          id: line.id,
          code: line.code,
          description: line.description,
          pvp: line.pvp,
          dto: line.dto,
          iva: line.iva,
          pvu: line.pvu,
          uds: line.uds,
          total: line.total,
          cardId: -1,
          stock: line.stock,
        };
        lines.push(row);
        index++;
      });

      v.carts.forEach((cart, cartIndex) => {
        const cartRow = {
          type: "user-line",
          cartId: cart.id,
          patient: cart.patientCode + " - " + cart.patientNameLastName,
          pic: cart.patientPic,
        };
        lines.push(cartRow);
        index++;
        cart.lines.forEach((line, lineIndex) => {
          const row = {
            index,
            type: "sale-line",
            id: line.id,
            code: line.code,
            description: line.description,
            pvp: line.pvp,
            dto: line.dto,
            iva: line.iva,
            pvu: line.pvu,
            uds: line.uds,
            total: line.total,
            cardId: cart.id,
            cartIndex,
            lineIndex,
            stock: line.stock,
          };
          lines.push(row);
          index++;
        });
      });

      return lines;
    };

    const getLineRef = (ventaN, row) =>
      row.cardId === -1
        ? ventaN.lines[row.index]
        : ventaN.carts[row.cartIndex].lines[row.lineIndex];

    const loadPaymentMethods = async () => {
      const response = await post("ListarFormasPago.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      const fPago = response.map((item) => {
        return {
          id: item.id,
          text: item.descripcion,
        };
      });
      setPaymentMethods(fPago);
    };

    const loadCardTypes = async () => {
      const response = await post("ListarTiposTarjeta.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      const tTarjeta = response.map((item) => {
        return {
          id: item.id,
          text: item.descripcion,
        };
      });
      tTarjeta.unshift({
        id: "",
        text: "",
      });
      setCardTypes(tTarjeta);
    };

    const loadAgents = async () => {
      const response = await rpost("fichas/ListarAgentes.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      let agentsN = response.map((item) => {
        return {
          id: item.id,
          text: item.nombreApellidos,
        };
      });
      agentsN.unshift({
        id: -1,
        text: "",
      });
      setAgents(agentsN);
    };

    const loadCampaigns = async () => {
      const response = await post("ListarCampanas.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
        incluirCampanasCRM: true,
        incluirCampanasCRMSoloActivas: true,
      });

      let campaignsN = response.map((item, index) => {
        return {
          id: index,
          text: item,
        };
      });
      campaignsN.unshift({
        id: -1,
        text: "",
      });
      setCampaigns(campaignsN);
    };

    const loadTiposIVA = async () => {
      const response = await post("ListarTiposIVA.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
      });
      setTiposIVA(response.tiposIVA);
      setIVASuperRed(response.superReducido);
    };

    const loadTiposCrossSelling = async () => {
      const response = await post("ListarTiposCrossSelling.php", {
        token: userData.token,
      });
      const tiposCrossSellingN = response.map((item) => {
        return {
          id: item,
          text: item,
        };
      });
      tiposCrossSellingN.unshift({
        id: -1,
        text: "",
      });
      setTiposCrossSelling(tiposCrossSellingN);
    };

    const loadOpticConfig = async () => {
      const response = await rpost(
        "ventas/ObtenerConfiguracionOpticaPreProf.php",
        {
          token: userData.token,
          idOptica: selectedOptic.id,
        },
      );
      const opticConfigN = {
        diasValidezPrePro: response.diasValidezPrePro,
      };
      setOpticConfig(opticConfigN);
      return opticConfigN;
    };

    const getProducts = async (text) => {
      let result = [];
      if (text.length >= 3) {
        const response = await post("BuscarProductos.php", {
          token: userData.token,
          texto: text,
          total: NUM_PRODUCTS_LIMIT,
        });
        result = response.map((item) => {
          const name = item.marca + " " + item.nombre;
          return {
            id: name,
            text: name,
            element: item,
          };
        });
      }
      return result;
    };

    const readProduct = async (code, index) => {
      if (code.trim() === "") {
        return true;
      }

      const response = await post("ObtenerProducto.php", {
        token: userData.token,
        codigo: code,
        idOptica: selectedOptic.id,
      });

      if (response.codigoOPTIWIN) {
        /* const pos = venta.lines.findIndex((item) => {
          return item.code === response.codigoOPTIWIN;
        });

        if (pos >= 0) {
          if (pos === index) {
            // Found in table, same line
            let ventaN = structuredClone(venta);

            ventaN.lines[index].uds++;

            const res = calculateDtoFromAll(
              ventaN.lines[pos].pvp,
              venta.patientDto,
              ventaN.lines[pos].pvpOffer,
              ventaN.lines[pos].offerFrom,
              ventaN.lines[pos].offerTo,
              ventaN.lines[pos].pvpSpecial,
              ventaN.lines[pos].specialUds,
              ventaN.lines[pos].uds,
              ventaN.lines[pos].dtoMax,
              createPopupQuestion,
              removePopupQuestion,
            );

            const dto = res.dto;
            const pvu = res.pvu;

            ventaN.lines[index].code = response.codigoOPTIWIN;
            ventaN.lines[pos].dto = dto;
            ventaN.lines[pos].pvu = pvu;
            ventaN.lines[index].total =
              ventaN.lines[pos].pvu * ventaN.lines[pos].uds;
            ventaN.lines[index].stock = response.sinControlStock
              ? ""
              : response.stock;

            ventaN = updateVentasTotal(ventaN);

            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
          } else {
            // Found in table, different line
            let ventaN = structuredClone(venta);

            ventaN.lines[pos].uds++;

            const res = calculateDtoFromAll(
              ventaN.lines[pos].pvp,
              venta.patientDto,
              ventaN.lines[pos].pvpOffer,
              ventaN.lines[pos].offerFrom,
              ventaN.lines[pos].offerTo,
              ventaN.lines[pos].pvpSpecial,
              ventaN.lines[pos].specialUds,
              ventaN.lines[pos].uds,
              ventaN.lines[pos].dtoMax,
              createPopupQuestion,
              removePopupQuestion,
            );

            const dto = res.dto;
            const pvu = res.pvu;

            ventaN.lines[pos].code = response.codigoOPTIWIN;
            ventaN.lines[pos].stock = response.sinControlStock
              ? ""
              : response.stock;
            ventaN.lines[pos].dto = dto;
            ventaN.lines[pos].pvu = pvu;
            ventaN.lines[pos].total =
              ventaN.lines[pos].pvu * ventaN.lines[pos].uds;

            ventaN.lines = ventaN.lines.filter((line, i) => {
              return index !== i;
            });

            ventaN = updateVentasTotal(ventaN);

            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
          }
        } else { */
        // Not found in table, replace

        let ventaN = structuredClone(venta);

        const res = calculateDtoFromAll(
          response.pvp,
          venta.patientDto,
          response.pvpOferta,
          response.fechaOfertaInicio,
          response.fechaOfertaFin,
          response.pvpEspecial,
          response.unidadesPvpEspecial,
          1,
          response.dtoMaximo,
          createPopupQuestion,
          removePopupQuestion,
        );

        const dto = res.dto;
        const pvu = res.pvu;

        ventaN.lines[index].dto = dto;

        ventaN.lines[index].code = response.codigoOPTIWIN;
        ventaN.lines[index].description = response.nombre;
        ventaN.lines[index].pvpOr = response.pvp;
        ventaN.lines[index].pvp = response.pvp;
        ventaN.lines[index].ivaOr = response.iva;
        ventaN.lines[index].iva = response.iva;
        ventaN.lines[index].pvu = pvu;
        ventaN.lines[index].uds = 1;
        ventaN.lines[index].total = ventaN.lines[index].pvu;
        ventaN.lines[index].stock = response.sinControlStock
          ? ""
          : response.stock;
        ventaN.lines[index].dtoMax = response.dtoMaximo;
        ventaN.lines[index].pvpOffer = response.pvpOferta;
        ventaN.lines[index].offerFrom = response.fechaOfertaInicio;
        ventaN.lines[index].offerTo = response.fechaOfertaFin;
        ventaN.lines[index].pvpSpecial = response.pvpEspecial;
        ventaN.lines[index].specialUds = response.unidadesPvpEspecial;
        ventaN.lines[index].checkStock = response.sinControlStock;
        ventaN.lines[index].total = ventaN.lines[index].pvu;
        ventaN.lines[index].healthControl = null;
        ventaN.lines[index].provider = response.proveedorNombre;
        ventaN.lines[index].providerId = response.proveedorId;
        ventaN.lines[index].commision = response.comision;
        ventaN.lines[index].ivaBought = response.ivaCompra;

        ventaN.lines[index].lastPurchaseBruto =
          response.precioBrutoUltimaCompra;
        ventaN.lines[index].lastPurchaseNeto = response.precioNetoUltimaCompra;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));

        return true;
        /* } */
      } else {
        // Product not found, empty line
        /* let ventaN = structuredClone(venta);
        ventaN.lines[index].code = code;
        ventaN.lines[index].description = "";
        ventaN.lines[index].pvpOr = 0;
        ventaN.lines[index].pvp = 0;
        ventaN.lines[index].dto =
          ventaN.patientDto !== "" ? ventaN.patientDto : 0;
        ventaN.lines[index].ivaOr = 0;
        ventaN.lines[index].iva = 0;
        ventaN.lines[index].pvu = 0;
        ventaN.lines[index].uds = 1;
        ventaN.lines[index].total = 0;
        ventaN.lines[index].stock = "";
        ventaN.lines[index].dtoMax = "";
        ventaN.lines[index].pvpOffer = "";
        ventaN.lines[index].offerFrom = "";
        ventaN.lines[index].offerTo = "";
        ventaN.lines[index].pvpSpecial = "";
        ventaN.lines[index].specialUds = 2;
        ventaN.lines[index].checkStock = false;
        ventaN.lines[index].healthControl = null;
        ventaN.lines[index].provider = "";
        ventaN.lines[index].providerId = "";
        ventaN.lines[index].commision = "";
        ventaN.lines[index].ivaBought = 0;
        ventaN.lines[index].lastPurchaseBruto = "";
        ventaN.lines[index].lastPurchaseNeto = "";

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN)); */

        createPopupQuestion(
          "Código no encontrado en almacén.",
          () => {
            const ventaN = structuredClone(venta);
            ventaN.lines[index].code = "";
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            removePopupQuestion();
            setTimeout(() => {
              const el = document.getElementById("ntc-" + (index + 1) + "-1");
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Entendido",
        );

        return false;
      }
    };

    const selectProduct = async (product, index) => {
      if (product.codigoOPTIWIN !== venta.lines[index].code) {
        // Not the same product, replace
        readProduct(product.codigoOPTIWIN, index);
      }
    };

    const loadVenta = async () => {
      setLoading(true);

      const opticConfigN = await loadOpticConfig();

      let ventaN = structuredClone(newQuote);

      if (saleId === -1) {
        let idPaciente = -1;

        if (orderPatientId === -1) {
          // Paciente 0 (genérico) por defecto

          let response = await post("ObtenerIdentificadorPaciente.php", {
            token: userData.token,
            optica: selectedOptic.id,
            codigoPaciente: orderPatientId !== -1 ? orderPatientId : "0",
          });

          if (response.error === "") {
            idPaciente = response.idPaciente;
          }
        } else {
          idPaciente = orderPatientId;
        }

        let response = await post("ObtenerDatosPaciente.php", {
          token: userData.token,
          optica: selectedOptic.id,
          idPaciente: idPaciente,
        });

        ventaN.patientDto =
          response.descuentoEspecial == 0 ? "" : response.descuentoEspecial;

        ventaN.idPaciente = idPaciente;
        ventaN.codPaciente = response.codigo;
        ventaN.name = response.nombre;
        ventaN.lastName = response.apellidos;
        ventaN.address = response.direccion;
        ventaN.city = response.localidad;
        ventaN.province = response.provincia;
        ventaN.postalCode = response.codigoPostal;
        ventaN.nif = response.nif;
        ventaN.phone = response.telefono;

        ventaN.lines[0].dto = ventaN.patientDto === "" ? 0 : ventaN.patientDto;

        ventaN.date = moment().format("YYYY-MM-DD HH:mm:ss");
        ventaN.performedBy = userData.id;

        ventaN.expirationDate = moment()
          .add(opticConfigN.diasValidezPrePro, "days")
          .format("YYYY-MM-DD");

        let agent = agents.find((item) => {
          return item.id === ventaN.performedBy;
        });
        if (agent) {
          setFilterRealizadoPor(agent);
        }

        if (orderCards.length > 0) {
          // Viene directo de una ficha o del carrito de la pantalla de pacientes

          let n = -1;

          for (let o = 0; o < orderCards.length; o++) {
            const orderCard = orderCards[o];

            let resp = await post("ObtenerDatosPaciente.php", {
              token: userData.token,
              optica: selectedOptic.id,
              idPaciente: orderCard.patientId,
            });

            const card = {
              cardId: orderCard.cardId,
              cardType: orderCard.category,
              id: orderCard.cardId,
              patientId: orderCard.patientId,
              patientCode: resp.codigo,
              patientNameLastName: resp.nombre + " " + resp.apellidos,
              selected: true,
              total: orderCard.lines.reduce((acc, line) => acc + line.total, 0),
              lines: [],
            };

            /*let endpoint="";
            switch (response.)*/

            resp = await post("ObtenerFotoPaciente.php", {
              token: userData.token,
              optica: selectedOptic.id,
              idPaciente: orderCard.patientId,
            });

            card.patientPic = transformPatientPicture(resp.foto);

            for (let i = 0; i < orderCard.lines.length; i++) {
              const l = orderCard.lines[i];
              if ((l.code !== "") & (l.code !== null) && l.code !== undefined) {
                let line = structuredClone(newSaleLine);
                line.id = l.id;
                line.code = l.code;
                line.description = l.description;
                line.pvp = l.pvp;
                line.dto = l.porcDto;
                line.iva = l.porcIva;
                line.pvu = l.pvp - (l.pvp * l.porcDto) / 100;
                line.total = l.total;
                line.cardId = orderCard.cardId;
                line.cardType = orderCard.category;

                line = await completeLine(line);

                card.lines.push(line);

                n--;
              }
            }

            ventaN.carts.push(card);
          }

          // Campaña: motivo seleccionado en la ficha
          const cardCampaign = orderCards.find((o) => o.campaign)?.campaign;
          if (cardCampaign) {
            const fCampaign = campaigns.find(
              (item) => item.text === cardCampaign,
            );
            if (fCampaign) {
              ventaN.campaign = fCampaign.id;
            }
          }

          ventaN = updateVentasTotal(ventaN);

          setNId(n);
        }

        setExpired(false);

        setTimeout(() => {
          const inputPatientCode = document.querySelector(
            "input#codigorec-quote",
          );
          inputPatientCode.focus();
          inputPatientCode.select();
        }, 200);
      } else {
        let response = await rpost("ventas/ObtenerProforma.php", {
          token: userData.token,
          idOptica: selectedOptic.id,
          idProforma: saleId,
          nProforma: "",
        });

        ventaN.id = response.idProforma;
        ventaN.idPaciente = response.idCliente;
        ventaN.codPaciente = response.numero_cliente;
        ventaN.nOperation = response.nProforma;
        ventaN.name = response.nombre_cliente;
        ventaN.lastName = response.apellidos_cliente;
        ventaN.address = response.direccion;
        ventaN.city = response.localidad;
        ventaN.province = response.provincia;
        ventaN.postalCode = response.codigo_postal;
        ventaN.nif = response.nif_cliente;
        ventaN.nifType = "00";
        ventaN.date = response.fecha + " " + response.hora;
        ventaN.phone = response.telefono;
        ventaN.status = response.vendido ? "Venta" : "Proforma";
        ventaN.observations = response.observaciones;
        ventaN.performedBy = -1;
        ventaN.campaign = -1;
        ventaN.accepted = response.aceptado;
        ventaN.expirationDate = response.fechaValidez;

        ventaN.lines = [];

        for (let i = 0; i < response.lineas.length; i++) {
          const line = response.lineas[i];

          let checkStock = false;
          let stock = "";
          let dtoMax = "";
          let pvpOffer = "";
          let offerFrom = "";
          let offerTo = "";
          let pvpSpecial = "";
          let specialUds = 2;

          if (line.codigo !== "") {
            const resp = await post("ObtenerProducto.php", {
              token: userData.token,
              codigo: line.codigo,
              idOptica: selectedOptic.id,
            });

            if (resp.codigoOPTIWIN) {
              checkStock = resp.sinControlStock;
              stock = resp.sinControlStock ? "" : resp.stock;
              dtoMax = resp.dtoMaximo;
              pvpOffer = resp.pvpOferta;
              offerFrom = resp.fechaOfertaInicio;
              offerTo = resp.fechaOfertaFin;
              pvpSpecial = resp.pvpEspecial;
              specialUds = resp.unidadesPvpEspecial;
            }
          }

          const l = {
            id: i,
            code: line.codigo,
            description: line.descripcion,
            pvpOr: -1,
            pvp: line.pvp_bruto_coniva,
            dto: line.dto,
            ivaOr: -1,
            iva: line.tipo_iva,
            pvu: line.pvp_neto_coniva,
            uds: line.cantidad,
            total: line.total,
            stock,
            dtoMax,
            pvpOffer,
            offerFrom,
            offerTo,
            pvpSpecial,
            specialUds,
            checkStock,
            healthControl: null,
            provider: line.proveedor,
            providerId: line.idProveedor,
            commision: "",
            ivaBought: 0,
            cardId: line.id_ficha,
            cardType: line.tipo_ficha,
            lastPurchaseBruto: "",
            lastPurchaseNeto: "",
          };

          if (l.cardId !== -1) {
            // Es línea de ficha

            l.id = "ntc-" + l.id;

            let cart = ventaN.carts.find((c) => c.id === l.cardId);
            if (!cart) {
              let resp = await post("ObtenerDatosPacienteDesdeFicha.php", {
                token: userData.token,
                idFicha: l.cardId,
              });

              cart = {
                id: l.cardId,
                patientCode: resp.codPaciente,
                patientNameLastName: resp.nombre + " " + resp.apellidos,
                patientPic: "",
                lines: [],
              };

              resp = await post("ObtenerFotoPaciente.php", {
                token: userData.token,
                optica: selectedOptic.id,
                idPaciente: resp.idPaciente,
              });

              cart.patientPic = transformPatientPicture(resp.foto);

              ventaN.carts.push(cart);
            }

            cart.lines.push(l);
          } else {
            // Es línea normal

            ventaN.lines.push(l);
          }
        }

        const today = moment();
        const expiredN = today.format("YYYY-MM-DD") > ventaN.expirationDate;
        setExpired(expiredN);

        const addedBlankLine =
          ventaN.status !== "Venta" && !expiredN && ventaN.lines.length === 0;
        if (addedBlankLine) {
          ventaN.lines.push(structuredClone(newSaleLine));
        }

        ventaN.totalDto = 0;
        ventaN.totalBase = 0;
        ventaN.totalIVA = 0;
        ventaN.total = 0;
        ventaN.ivas = response.ivas.map((iva) => {
          return {
            percIva: iva.tipo,
            base: iva.base,
            iva: iva.iva,
            total: iva.total,
          };
        });

        response.lineas.forEach((line) => {
          ventaN.totalDto += line.dto_coniva * line.cantidad;
          ventaN.totalBase += line.base * line.cantidad;
          ventaN.totalIVA += line.iva * line.cantidad;
          ventaN.total += line.total;
        });

        let fPerformedBy = agents.find((item) => {
          return item.text === response.empleado;
        });
        if (!fPerformedBy) {
          fPerformedBy = agents[0];
        }
        ventaN.performedBy = fPerformedBy.id;
        setFilterRealizadoPor(fPerformedBy);

        let fCampaign = campaigns.find((item) => {
          return item.text === response.motivo_agente;
        });
        if (!fCampaign) {
          fCampaign = campaigns[0];
        }
        ventaN.campaign = fCampaign.id;

        response = await post("ObtenerDatosPaciente.php", {
          token: userData.token,
          optica: selectedOptic.id,
          idPaciente: ventaN.idPaciente,
        });

        ventaN.patientDto =
          response.descuentoEspecial == 0 ? "" : response.descuentoEspecial;
        if (addedBlankLine) {
          ventaN.lines[ventaN.lines.length - 1].dto =
            response.descuentoEspecial == 0 ? 0 : response.descuentoEspecial;
        }
      }

      const campaign = campaigns.find((item) => {
        return item.id == ventaN.campaign;
      });
      if (campaign) {
        setFilterCampaign(campaign);
      }

      ventaN = createIVASummary(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));

      setTotalDtoF(formatCurrency(ventaN.totalDto));
      setTotalBaseF(formatCurrency(ventaN.totalBase));
      setTotalIVAF(formatCurrency(ventaN.totalIVA));

      //setEmptySale(ventaN);

      if (
        (saleId === -1 && orderCards.length === 0 && orderPatientId === -1) ||
        saleId !== -1
      ) {
        setEmptySale(ventaN);
      } else {
        setEmptySale(emptySale);
      }

      setLoading(false);
    };

    const createNewRow = () => {
      const pos = venta.lines.findIndex((line) => {
        return line.code.trim() === "" && line.description.trim() === "";
      });
      if (pos === -1) {
        const item = structuredClone(newSaleLine);
        item.dto = venta.patientDto === "" ? 0 : venta.patientDto;
        item.id = nId - 1;
        let ventaN = structuredClone(venta);
        ventaN.lines.push(item);
        ventaN = updateVentasTotal(ventaN);
        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
        setNId(nId - 1);
        setTimeout(() => {
          const el = document.getElementById(
            "ntc-" + (venta.lines.length + 1) + "-1",
          );
          if (el) {
            el.focus();
          }
        }, 100);
      } else {
        const el = document.getElementById("ntc-" + (pos + 1) + "-1");
        if (el) {
          el.focus();
        }
      }
    };

    const removeLine = (index) => {
      let ventaN = structuredClone(venta);
      ventaN.lines = ventaN.lines.filter((line, i) => {
        return i !== index;
      });

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));

      if (ventaN.lines.length === 0) {
        setForceCreateNewRow(true);
      }
    };

    const createIVASummary = (v) => {
      const ivas = [];
      v.lines.forEach((line) => {
        if (line.code.trim() !== "" || line.description.trim() !== "") {
          const percIva = parseInt(line.iva);
          const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
          const iva = line.pvu * line.uds - base;
          const total = line.total;
          let ivaInfo = ivas.find((i) => {
            return i.percIva === percIva;
          });
          if (!ivaInfo) {
            ivaInfo = {
              percIva,
              base,
              iva,
              total,
            };
            ivas.push(ivaInfo);
          } else {
            ivaInfo.base += base;
            ivaInfo.iva += iva;
            ivaInfo.total += total;
          }
        }
      });

      v.carts.forEach((cart) => {
        cart.lines.forEach((line) => {
          const percIva = parseInt(line.iva);
          const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
          const iva = line.pvu * line.uds - base;
          const total = line.total;
          let ivaInfo = ivas.find((i) => {
            return i.percIva === percIva;
          });
          if (!ivaInfo) {
            ivaInfo = {
              percIva,
              base,
              iva,
              total,
            };
            ivas.push(ivaInfo);
          } else {
            ivaInfo.base += base;
            ivaInfo.iva += iva;
            ivaInfo.total += total;
          }
        });
      });

      v.ivas = ivas;
      return v;
    };

    const updateVentasTotal = (v) => {
      let totalDto = 0;
      let totalBase = 0;
      let totalIVA = 0;
      let total = 0;
      v.lines.forEach((line) => {
        //totalDto = totalDto + line.pvp * (line.dto / 100) * line.uds;
        totalDto = totalDto + line.pvp * line.uds - line.pvu * line.uds;
        const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
        totalBase += base;
        totalIVA = totalIVA + (line.pvu * line.uds - base);
        total = total + line.total;
      });
      v.carts.forEach((cart) => {
        cart.lines.forEach((line) => {
          //totalDto = totalDto + line.pvp * (line.dto / 100) * line.uds;
          totalDto = totalDto + line.pvp * line.uds - line.pvu * line.uds;
          const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
          totalBase += base;
          totalIVA = totalIVA + (line.pvu * line.uds - base);
          total = total + line.total;
        });
      });
      v.totalDto = Math.round(totalDto * 100) / 100;
      v.totalBase = Math.round(totalBase * 100) / 100;
      v.totalIVA = Math.round(totalIVA * 100) / 100;
      v.total = Math.round(total * 100) / 100;
      v = createIVASummary(v);
      setTotalDtoF(formatCurrency(v.totalDto));
      setTotalBaseF(formatCurrency(v.totalBase));
      setTotalIVAF(formatCurrency(v.totalIVA));

      return v;
    };

    const onSelectPatient = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.idPaciente = e.idPaciente;
      ventaN.codPaciente = e.codigo;
      ventaN.name = e.nombre;
      ventaN.lastName = e.apellidos;
      ventaN.address = e.direccion;
      ventaN.city = e.localidad;
      ventaN.province = e.provincia;
      ventaN.postalCode = e.codigoPostal;
      ventaN.nif = e.nif;
      ventaN.phone = e.telefono;
      ventaN.factCodPaciente = e.idPaciente;
      ventaN.factName = e.nombre + " " + e.apellidos;
      ventaN.factNif = e.nif;
      ventaN.factAddress = e.direccion;
      ventaN.factCity = e.localidad;
      ventaN.factProvince = e.provincia;
      ventaN.factPostalCode = e.codigoPostal;
      ventaN.patientDto = e.descuento;

      ventaN.lines.forEach((line) => {
        if (line.code.trim() === "" && line.description.trim() === "") {
          line.dto = ventaN.patientDto;
          line.pvu = calculatePVU(line.pvp, line.dto);
          line.total = line.pvu * line.uds;
        }
      });

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));

      const el = document.querySelector(
        "div.rdt_TableRow > div:first-child input",
      );
      if (el) {
        el.focus();
      }
    };

    const onChangeNombre = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.name = e;
      setVenta(ventaN);
    };

    const onChangeApellidos = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.lastName = e;
      setVenta(ventaN);
    };

    const onChangePhone = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.phone = e;
      setVenta(ventaN);
    };

    const onLinkPatient = () => {
      if (venta.codPaciente !== "") {
        window.open(`/patient-datos/${venta.idPaciente}`);
      }
    };

    const onChangeFilterCampaign = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.campaign = e.id;
      setVenta(ventaN);
      setFilterCampaign(e);
    };

    const onChangePVPLine = (value, row) => {
      let pvp = value;
      if (pvp < 0) {
        pvp = 0;
      }
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);
      line.pvp = pvp;
      line.pvu = calculatePVU(line.pvp, line.dto);
      line.total = line.pvu * line.uds;

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
    };

    const onChangeDtoLine = (value, row) => {
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);
      if (line.dtoMax !== "" && value > line.dtoMax) {
        createPopupQuestion(
          "El descuento introducido (" +
            value +
            "%) no debe ser mayor al descuento máximo permitido por el producto (" +
            line.dtoMax +
            "%).",
          () => {
            const dto = getLineRef(venta, row).dto;
            line.dto = 1;
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            removePopupQuestion();
            setTimeout(() => {
              line.dto = dto;
              setVenta(ventaN);
              setVentaLinesTable(createVentaLinesTable(ventaN));
              removePopupQuestion();
              const el = document.querySelector(
                "#ntc-" + (row.index + 1) + "-4",
              );
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Cerrar",
        );
      } else {
        let dto = value;
        if (dto < 0) {
          dto = 0;
        }
        if (dto > 100) {
          dto = 100;
        }
        line.dto = dto;
        line.pvu = calculatePVU(line.pvp, line.dto);
        line.total = line.pvu * line.uds;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
      }
    };

    const onChangePVULine = (value, row) => {
      let pvu = parseFloat(value) || 0;
      const pvp = parseFloat(getLineRef(venta, row).pvp) || 0;
      if (pvu > pvp) {
        pvu = pvp;
      }
      if (pvu < 0) {
        pvu = 0;
      }
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);
      line.pvu = pvu;
      line.dto = calculateDto(line.pvp, line.pvu);
      line.total = line.pvu * line.uds;

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
    };

    const onChangeTotalLine = (value, row) => {
      const totalN = parseFloat(value);
      const line = getLineRef(venta, row);

      const linesN = [
        {
          id: line.code === "" ? line.description : line.code,
          total: line.total,
          dto: parseFloat(line.dto) || 0,
          dtoMax: line.code === "" ? "" : line.dtoMax,
        },
      ];

      const result = calculateDtos(linesN, totalN, false);
      if (result.error === "") {
        let ventaN = structuredClone(venta);
        const l = getLineRef(ventaN, row);
        l.total = result.lines[0].total;
        l.dto = result.lines[0].dto;
        l.pvu = l.total / l.uds;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
      } else {
        createPopupQuestion(result.error, removePopupQuestion, null);
        const totalOr = line.total;
        let ventaN = structuredClone(venta);
        getLineRef(ventaN, row).total = totalN;
        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
        setTimeout(() => {
          let ventaN2 = structuredClone(venta);
          getLineRef(ventaN2, row).total = totalOr;
          setVenta(ventaN2);
          setVentaLinesTable(createVentaLinesTable(ventaN2));
        }, 100);
      }
    };

    const onChangeUdsLine = (value, row) => {
      let uds = value;
      if (uds < 0) {
        uds = 0;
      }
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);

      line.uds = uds;

      const res = calculateDtoFromAll(
        line.pvp,
        venta.patientDto,
        line.pvpOffer,
        line.offerFrom,
        line.offerTo,
        line.pvpSpecial,
        line.specialUds,
        line.uds,
        line.dtoMax,
        createPopupQuestion,
        removePopupQuestion,
      );

      // Se conserva el descuento actual de la línea (manual o calculado) salvo
      // que la oferta o el precio especial por unidades den uno mayor.
      if (res.dto > (parseFloat(line.dto) || 0)) {
        line.dto = res.dto;
        line.pvu = res.pvu;
      } else {
        line.pvu = calculatePVU(line.pvp, line.dto);
      }
      line.total = line.pvu * line.uds;

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
    };

    const onChangeIVALine = (value, row) => {
      const pos = tiposIVA.findIndex((iva) => {
        return iva == value;
      });

      if (pos === -1) {
        createPopupQuestion("Tipo de IVA inválido: " + value + "%.", () => {
          const iva = getLineRef(venta, row).iva;
          let ventaN = structuredClone(venta);
          const line = getLineRef(ventaN, row);
          line.iva = 0;
          setVenta(ventaN);
          setVentaLinesTable(createVentaLinesTable(ventaN));
          removePopupQuestion();
          setTimeout(() => {
            line.iva = iva;
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            const el = document.querySelector("#ntc-" + (row.index + 1) + "-5");
            if (el) {
              el.focus();
            }
          }, 1);
        });
      } else {
        let ventaN = structuredClone(venta);
        const line = getLineRef(ventaN, row);

        if (value == IVASuperRed && line.iva != IVASuperRed) {
          // IVA Especial
          const result = calculateIVASuperRed(
            line.pvp,
            line.dto,
            line.uds,
            IVASuperRed,
          );

          line.pvp = result.pvp;
          line.pvu = result.pvu;
          line.total = result.total;
        }

        line.iva = value;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
      }
    };

    const showAddressPopup = (show) => {
      const address = show
        ? {
            address: venta.address,
            city: venta.city,
            province: venta.province,
            postalCode: venta.postalCode,
          }
        : null;
      setAddress(address);
    };

    const onChangeAddress = (e) => {
      const addressN = structuredClone(address);
      addressN.address = e;
      setAddress(addressN);
    };

    const onChangePostalCode = (e) => {
      const addressN = structuredClone(address);
      addressN.postalCode = e;
      setAddress(addressN);
    };

    const onChangeCity = (e) => {
      const addressN = structuredClone(address);
      addressN.city = e;
      setAddress(addressN);
    };

    const onChangeProvince = (e) => {
      const addressN = structuredClone(address);
      addressN.province = e.id;
      setAddress(addressN);
    };

    const saveAddress = () => {
      const ventaN = structuredClone(venta);
      ventaN.address = address.address;
      ventaN.city = address.city;
      ventaN.province = address.province;
      ventaN.postalCode = address.postalCode;
      setVenta(ventaN);
      setAddress(null);
    };

    const getValidLines = (considerCarts) => {
      const lines = [];
      venta.lines.forEach((line) => {
        if (line.code.trim() !== "" || line.description.trim() !== "") {
          lines.push(line);
        }
      });
      if (considerCarts) {
        venta.carts.forEach((cart) => {
          cart.lines.forEach((line) => {
            lines.push(line);
          });
        });
      }
      return lines;
    };

    const onBlurTotal = (e) => {
      let error = "";
      const totalN = parseFloat(e);
      if (totalN !== venta.total) {
        const linesWithIndex = [];
        venta.lines.forEach((line, index) => {
          if (line.code.trim() !== "" || line.description.trim() !== "") {
            linesWithIndex.push({ line, index });
          }
        });
        if (linesWithIndex.length > 0) {
          const linesN = linesWithIndex.map(({ line }) => {
            return {
              id: line.code === "" ? line.description : line.code,
              total: line.total,
              dto: parseFloat(line.dto) || 0,
              dtoMax: line.code === "" ? "" : line.dtoMax,
            };
          });

          // Calculate discount (only applicable to product lines, no carts)
          const linesTotalProducts = linesN.reduce(
            (acc, curr) => (acc += curr.total),
            0,
          );
          let linesTotalCarts = 0;
          venta.carts.forEach((cart) => {
            cart.lines.forEach((cartLine) => {
              linesTotalCarts += cartLine.total;
            });
          });
          const total = linesTotalProducts + linesTotalCarts;
          const reduction = total - totalN;
          const linesTotal = linesTotalProducts - reduction;

          const result = calculateDtos(linesN, linesTotal, false);
          if (result.error === "") {
            let ventaN = structuredClone(venta);
            result.lines.forEach((line, i) => {
              // calculateDtos devuelve result.lines en el mismo orden que
              // linesN, así que reemparejamos por posición (linesWithIndex[i])
              // en vez de por código, para no confundir líneas con datos
              // idénticos (p. ej. el mismo producto en varias líneas).
              const l = ventaN.lines[linesWithIndex[i].index];
              if (l) {
                l.total = line.total;
                l.pvu = l.total / l.uds;
                l.dto = line.dto;
              }
            });

            ventaN = updateVentasTotal(ventaN);

            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
          } else {
            error = result.error;
          }
        } else {
          error = "Debe insertar productos en la factura proforma.";
        }
      }
      if (error !== "") {
        createPopupQuestion(error, removePopupQuestion, null);
        const totalOr = venta.total;
        const ventaN = structuredClone(venta);
        ventaN.total = totalN;
        setVenta(ventaN);
        setTimeout(() => {
          const ventaN = structuredClone(venta);
          ventaN.total = totalOr;
          setVenta(ventaN);
        }, 100);
      }
    };

    const onRemoveCart = (cartId) => {
      const cart = venta.carts.find((c) => c.id === cartId);
      if (cart) {
        createPopupQuestion(
          `¿Desea devolver este elemento a la cesta de ${cart.patientNameLastName}?`,
          () => {
            let ventaN = structuredClone(venta);
            ventaN.carts = ventaN.carts.filter((c) => c.id !== cartId);
            ventaN = updateVentasTotal(ventaN);
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            removePopupQuestion();
          },
          removePopupQuestion,
        );
      }
    };

    const loadCarts = async () => {
      const response = await rpost("ventas/ListarCestas.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
      });

      let cartsN = response.map((cart) => {
        const lines = cart.lineas.map((line) => {
          const l = {
            id: "c-" + line.id,
            code: line.codigoOPTIWIN,
            description: line.descripcion,
            pvp: line.pvp,
            dto: line.porcDto,
            iva: line.porcIVA,
            pvu: line.pvp - (line.pvp * line.porcDto) / 100,
            uds: 1,
            total: line.total,
            stock: line.stock,
            cardId: cart.idFicha,
            cardType:
              cart.categoria === "gafas" && cart.sol ? "SOL" : cart.categoria,
          };

          return l;
        });

        return {
          id: cart.idFicha,
          cardType:
            cart.categoria === "gafas" && cart.sol ? "SOL" : cart.categoria,
          patientCode: cart.codigoCliente,
          patientId: cart.idCliente,
          patientNameLastName: cart.nombreCliente,
          total: cart.total,
          lines,
        };
      });

      cartsN = cartsN.reduce((acc, curr) => {
        const pos = venta.carts.findIndex((cart) => {
          return cart.id === curr.id;
        });
        if (pos === -1) {
          acc.push({
            id: curr.id,
            patientId: curr.patientId,
            patientCode: curr.patientCode,
            patientNameLastName: curr.patientNameLastName,
            patientPic: "",
            cardType: curr.cardType,
            total: curr.total,
            lines: curr.lines,
            selected: false,
            cardId: curr.id,
          });
        }
        return acc;
      }, []);

      setCartPopup(cartsN);
      loadCartsPictures(cartsN);
    };

    const loadCartsPictures = async (carts) => {
      const cartsN = structuredClone(carts);
      for (let i = 0; i < cartsN.length; i++) {
        const cart = cartsN[i];
        const response = await post("ObtenerFotoPaciente.php", {
          token: userData.token,
          optica: selectedOptic.id,
          idPaciente: cart.patientId,
        });
        cart.patientPic = response.foto ? response.foto : "/images/avatar.svg";
      }

      setCartPopup(cartsN);
    };

    const onClickCartItem = (index) => {
      const carts = structuredClone(cartPopup);
      carts[index].selected = !carts[index].selected;
      setCartPopup(carts);
    };

    const completeLine = async (line) => {
      const response = await post("ObtenerProducto.php", {
        token: userData.token,
        codigo: line.code,
        idOptica: selectedOptic.id,
      });
      if (response.codigoOPTIWIN) {
        line.pvpOr = response.pvp;
        line.ivaOr = response.iva;
        line.iva = line.iva === -1 ? response.iva : line.iva;
        line.stock = response.sinControlStock ? "" : response.stock;
        line.dtoMax = response.dtoMaximo;
        line.checkStock = response.sinControlStock;
        line.provider = response.proveedorNombre;
        line.providerId = response.proveedorId;
        line.commision = response.comision;
        line.ivaBought = response.ivaCompra;
        line.lastPurchaseBruto = response.precioBrutoUltimaCompra;
        line.lastPurchaseNeto = response.precioNetoUltimaCompra;
      } else {
        const response = await post("ListarTiposIVA.php", {
          token: userData.token,
          idOptica: selectedOptic.id,
        });
        if (response.tiposIVA && response.tiposIVA.length > 0) {
          line.iva = Math.max(...response.tiposIVA);
        }
      }
      return line;
    };

    const addCartToSale = async () => {
      let ventaN = structuredClone(venta);
      for (let c = 0; c < cartPopup.length; c++) {
        const cart = cartPopup[c];
        if (cart.selected) {
          for (let i = 0; i < cart.lines.length; i++) {
            const line = cart.lines[i];

            let l = structuredClone(newSaleLine);
            l.id = line.id;

            l.code = line.code;
            l.description = line.description;
            l.pvp = line.pvp;
            l.dto = line.dto;
            l.iva = line.iva;
            l.pvu = line.pvu;
            l.uds = line.uds;
            l.total = line.total;
            l.cardId = line.cardId;
            l.cardType = cart.cardType;
            l = await completeLine(l);

            cart.lines[i] = l;
          }
          ventaN.carts.push(cart);
        }
      }

      ventaN = updateVentasTotal(ventaN);
      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
      setCartPopup(null);
    };

    const showPopupCart = (show) => {
      if (show) {
        loadCarts();
      } else {
        setCartPopup(false);
      }
    };

    const showNifTypePopup = (show) => {
      setNifTypePopup(show ? venta.nifType : "");
    };

    const acceptNifTypePopup = (nifType) => {
      const ventaN = structuredClone(venta);
      ventaN.nifType = nifType;
      setVenta(ventaN);
      setNifTypePopup("");
    };

    const loadScreen = async () => {
      loadAgents();
      loadCampaigns();
      loadCardTypes();
      loadTiposIVA();
      loadPaymentMethods();
      loadTiposCrossSelling();
    };

    const showPopupCPDialog = (show, address, city, type) => {
      setCPPopupAddress(address);
      setCPPopupCity(city);
      setCPPopupType(type);
      setShowPopupCP(show);
    };

    const onAcceptCP = (fullAddress) => {
      if (cpPopupType === "personal") {
        const addressN = structuredClone(address);
        addressN.postalCode = fullAddress.postalCode;
        setAddress(addressN);
      } else {
        const invoiceN = structuredClone(invoice);
        invoiceN.postalCode = fullAddress.postalCode;
        setInvoice(invoiceN);
      }
      showPopupCPDialog(false, "", "", "personal");
    };

    const saveSale = async () => {
      const linesF = getValidLines(true);

      if (linesF.length === 0) {
        createPopupQuestion(
          "Debe insertar productos en la factura proforma.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
        return;
      }

      const empleado = agents.find((agent) => agent.id === venta.performedBy);

      const motivo = campaigns.find(
        (campaign) => campaign.id === venta.campaign,
      );

      const descuentoGeneral = (venta.totalDto / venta.total) * 100;

      const lines = linesF.map((line) => {
        const pvpBruto = line.pvp;
        const pvpNeto = line.pvp - (line.pvp * line.dto) / 100;
        const dto = pvpBruto - pvpNeto;
        const pvpBrutoConIva = pvpBruto;
        const pvpBrutoSinIva = pvpBruto / (1 + line.iva / 100);
        const PvpNetoConIva = pvpNeto;
        const PvpNetoSinIva = pvpNeto / (1 + line.iva / 100);
        const dtoConIva = dto;
        const dtoSinIva = dto / (1 + line.iva / 100);
        const iva = PvpNetoConIva - PvpNetoSinIva;

        let compraBruto = "";
        let compraNeto = "";
        let beneficioBruto = "";
        let beneficioNeto = "";
        let porcBeneficioBruto = "";
        let porcBeneficioNeto = "";

        if (line.lastPurchaseBruto !== "") {
          compraBruto = line.lastPurchaseBruto * line.uds;
          compraNeto = line.lastPurchaseNeto * line.uds;
          beneficioBruto = pvpBruto * line.uds - compraBruto;
          beneficioNeto = pvpNeto * line.uds - compraNeto;
          porcBeneficioBruto = (beneficioBruto / compraBruto) * 100;
          porcBeneficioNeto = (beneficioNeto / compraNeto) * 100;
        }

        return {
          codigo: line.code,
          proveedor: line.provider,
          idProveedor: line.providerId,
          descripcion: line.description,
          pvp_bruto_siniva: pvpBrutoSinIva,
          pvp_bruto_coniva: pvpBrutoConIva,
          dto: line.dto,
          dto_siniva: dtoSinIva,
          dto_coniva: dtoConIva,
          pvp_neto_siniva: PvpNetoSinIva,
          pvp_neto_coniva: PvpNetoConIva,
          cantidad: line.uds,
          base: PvpNetoSinIva,
          tipo_iva: parseInt(line.iva),
          iva,
          total: line.total,
          pvp_especial: line.pvpSpecial,
          cantidad_especial: line.specialUds,
          pvp_original: line.pvpOr,
          comision: line.commision,
          importe_comision: (line.total * line.commision) / 100,
          id_ficha: line.cardId,
          numero_encargo: -1,
          numero_presupuesto: -1,
          numero_proforma: -1,
          tipo_ficha: line.cardId === -1 ? "T" : line.cardType[0].toUpperCase(),
          tipo_iva_compra: line.ivaBought,
          tipo_iva_venta: line.iva,
          precioBrutoCompra: compraBruto,
          precioNetoCompra: compraNeto,
          beneficioBruto,
          beneficioNeto,
          porcBrutoCompra: porcBeneficioBruto,
          porcNetoCompra: porcBeneficioNeto,
        };
      });

      const ivas = venta.ivas.map((item) => {
        const linesF = lines.filter((line) => line.tipo_iva === item.percIva);

        let brutoTotal = 0;
        let netoTotal = 0;
        linesF.forEach((line) => {
          brutoTotal = brutoTotal + line.pvp_bruto_coniva;
          netoTotal = netoTotal + line.pvp_neto_coniva;
        });
        const dtoTotal = brutoTotal - netoTotal;
        const dto = (dtoTotal / brutoTotal) * 100;

        return {
          tipo: item.percIva,
          suma: linesF.length,
          dto,
          total_dto: dtoTotal,
          base: item.base,
          iva: item.iva,
          total: item.total,
        };
      });

      const sale = {
        token: userData.token,
        idProforma: saleId,
        idOptica: selectedOptic.id,
        idCliente: venta.idPaciente,
        numero_cliente: venta.codPaciente,
        nombre_cliente: venta.name,
        apellidos_cliente: venta.lastName,
        nif_cliente: venta.nif,
        direccion: venta.address,
        codigo_postal: venta.postalCode,
        localidad: venta.city,
        provincia: venta.province,
        telefono: venta.phone,
        empleado: empleado.text,
        motivo_agente: motivo.text,
        total_proforma_bruto: venta.total + venta.totalDto,
        descuento_general: descuentoGeneral,
        total_dto_euros: venta.totalDto,
        total_proforma_neto: venta.total,
        lineas: lines,
        ivas,
        aceptado: venta.accepted,
        fechaValidez: venta.expirationDate,
        observaciones: venta.observations,
      };

      const response = await rpost("ventas/GuardarProforma.php", sale);

      if (response.error !== "") {
        createPopupQuestion(
          response.error,
          () => removePopupQuestion(),
          null,
          "Cerrar",
        );
      } else {
        createPopupQuestion(
          "Proforma guardada de manera correcta.",
          () => {
            removePopupQuestion();
            setEmptySale(venta);
            onClickMenuOption("proforma", {
              saleId: response.idProforma,
            });
          },
          null,
          "Cerrar",
        );
      }
    };

    const onGoToScreen = (screen, params) => {
      if (JSON.stringify(venta) === JSON.stringify(emptySale)) {
        onClickMenuOption(screen, params);
      } else {
        createPopupQuestion(
          saleId === -1
            ? "Existe una nueva factura proforma en proceso. ¿Desea abandonarla?"
            : "Existen cambios sin guardar. ¿Desea abandonar la factura proforma?",
          () => {
            if (screen === "proforma") {
              if (saleId === -1) {
                loadVenta();
              } else {
                onClickMenuOption("proforma", { saleId: -1 });
              }
            } else {
              onClickMenuOption(screen, params);
            }
            removePopupQuestion();
          },
          () => {
            removePopupQuestion();
          },
          "Salir",
          "Cancelar",
        );
      }
    };

    const onRemove = () => {
      createPopupQuestion(
        "¿Está seguro de que desea eliminar la factura proforma?",
        async () => {
          await rpost("ventas/EliminarProforma.php", {
            token: userData.token,
            idProforma: saleId,
            idAgente: userData.id,
          });
          removePopupQuestion();
          onClickMenuOption("ventas");
        },
        () => {
          removePopupQuestion();
        },
        "Eliminar",
        "Cancelar",
      );
    };

    const onChangePerformedBy = (value) => {
      const ventaN = structuredClone(venta);
      ventaN.performedBy = value.id;
      setVenta(ventaN);
    };

    const sendToSaleStep3 = () => {
      const ventaN = structuredClone(venta);
      ventaN.orderNumber = "";
      ventaN.quoteNumber = "";
      ventaN.proformaNumber = ventaN.nOperation;
      removePopupQuestion();
      onClickMenuOption("venta", {
        saleId: -1,
        createdSale: ventaN,
      });
    };

    const sendToSaleStep2 = () => {
      if (venta.accepted !== true) {
        createPopupQuestion(
          "Si formaliza la venta la factura proforma se marcará como aceptada. ¿Está seguro de que desea pasarla a venta?",
          async () => {
            sendToSaleStep3();
            removePopupQuestion();
          },
          () => {
            removePopupQuestion();
          },
          "Pasar a venta",
          "Cancelar",
        );
      } else {
        sendToSaleStep3();
      }
    };

    const sendToSaleStep1 = () => {
      if (JSON.stringify(venta) !== JSON.stringify(emptySale)) {
        createPopupQuestion(
          "Debe guardar la factura proforma antes de pasarla a venta.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
      } else {
        sendToSaleStep2();
      }
    };

    const onAcceptSale = (accepted) => {
      const ventaN = structuredClone(venta);
      ventaN.accepted =
        (venta.accepted === true && accepted) ||
        (venta.accepted === false && !accepted)
          ? ""
          : accepted;
      setVenta(ventaN);
    };

    const exportProformaReport = async (format) => {
      const titulosTabla = [
        `Cod. paciente: ${venta.codPaciente}`,
        `Nombre: ${venta.name}`,
        `Apellidos: ${venta.lastName}`,
        `Dirección: ${createAddress(venta.address, venta.city, venta.province, venta.postalCode)}`,
        `Fecha: ${moment(venta.date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss")}`,
        `Estado: ${venta.status.toUpperCase()}`,
        `Nº proforma: ${venta.nOperation}`,
        `Teléfono: ${venta.phone}`,
        `Realizado por: ${filterRealizadoPor.text}`,
        `Campaña: ${filterCampaign.text}`,
        `Aceptado: ${
          venta.accepted === true ? "SÍ" : venta.accepted === false ? "NO" : "-"
        }`,
      ];

      if (venta.observations) {
        titulosTabla.push(`Observaciones: ${venta.observations}`);
      }

      const tables = [
        {
          titulosTabla: [titulosTabla.join(", ")],
          numReferencias: "",
          extraCabeceras: [
            { titulo: "Total dto.", descripcion: totalDtoF },
            { titulo: "Total base", descripcion: totalBaseF },
            { titulo: "Total IVA", descripcion: totalIVAF },
            { titulo: "Total", descripcion: formatCurrency(venta.total) },
          ],
          cabeceras: [
            { titulo: "Codigo", tipo: "string" },
            { titulo: "Descripción del producto", tipo: "string" },
            { titulo: "PVP", tipo: "currency" },
            { titulo: "Dto", tipo: "perc" },
            { titulo: "IVA", tipo: "perc" },
            { titulo: "PVU", tipo: "currency" },
            { titulo: "Uds.", tipo: "int" },
            { titulo: "Total", tipo: "currency" },
          ],
          filas: getValidLines(true).map((line) => [
            line.code,
            line.description,
            formatCurrency(line.pvp),
            Math.round(parseFloat(line.dto) || 0) + " %",
            line.iva + " %",
            formatCurrency(line.pvu),
            line.uds,
            formatCurrency(line.total),
          ]),
        },
      ];

      await exportToFile(
        `PROFORMA con Nº proforma ${venta.nOperation}`,
        [],
        false,
        false,
        format,
        tables,
        -1,
        "",
      );
    };

    useEffect(() => {
      if (show && !loaded) {
        loadScreen();
      }
    }, [show]);

    useEffect(() => {
      if (forceCreateNewRow) {
        createNewRow();
        setForceCreateNewRow(false);
      }
    }, [forceCreateNewRow]);

    useEffect(() => {
      if (
        show &&
        agents &&
        campaigns &&
        paymentMethods &&
        cardTypes &&
        tiposIVA &&
        tiposCrossSelling &&
        saleId &&
        !loaded
      ) {
        loadVenta();
        setLoaded(true);
      }
    }, [
      show,
      agents,
      campaigns,
      paymentMethods,
      cardTypes,
      tiposIVA,
      tiposCrossSelling,
      saleId,
    ]);

    useEffect(() => {
      if (show && saleId != null && loaded) {
        loadVenta();
      }
    }, [show, saleId]);

    if (!show || venta == null) {
      return <></>;
    }

    return (
      <div className="patient-data sales-data sale-data sale-order-data">
        <div className="patient-data-header">
          <span className="header-text">Proforma</span>
        </div>
        {loading && (
          <LoadingScreen message="Cargando datos de factura proforma..." />
        )}
        {!loading && (
          <div className="patient-data-content store-data-content">
            <div className="action-bar action-bar-store">
              <div className="action-bar-resume">
                <span>TPV</span>
                <span>|</span>
                <span>Búsqueda de factura proforma</span>
                <span>|</span>
                <span className="signed-text">Proforma</span>
              </div>
            </div>
            <div
              className="store-info sales-info-header"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div className="sales-content">
                <div className="patient-search-content store-search-content">
                  <div className="general-header">
                    <div className="general-header-info">
                      <div className="screen-row screen-row-space-between screen-row-content">
                        <div className="screen-row-3">
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Cod. paciente</span>
                            </div>
                            <InputSearch
                              id="codigorec-quote"
                              size={1}
                              tabIndex={1}
                              link={true}
                              code={true}
                              op={venta.codPaciente}
                              onSelect={onSelectPatient}
                              onClickLink={onLinkPatient}
                              showCode={true}
                              disabled={venta.status === "Venta" || expired}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="screen-item">
                              <div className="cell-extra cell-extra-big-label">
                                <span className="label">Nombre</span>
                              </div>
                              <InputData
                                tabIndex={2}
                                type="type-alpha"
                                size={0}
                                input={venta.name}
                                onChange={onChangeNombre}
                                inactive={false}
                              />
                            </div>
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Apellidos</span>
                            </div>
                            <InputData
                              tabIndex={3}
                              type="type-alpha"
                              size={0}
                              input={venta.lastName}
                              onChange={onChangeApellidos}
                              inactive={false}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Dirección</span>
                            </div>
                            <InputData
                              tabIndex={4}
                              type="type-alpha"
                              size={0}
                              input={createAddress(
                                venta.address,
                                venta.city,
                                venta.province,
                                venta.postalCode,
                              )}
                              onChange={null}
                              inactive={true}
                            />
                            <div className="sale-edit-address-icon">
                              <img
                                src="/images/support-extra/editar.svg"
                                onClick={() => showAddressPopup(true)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="screen-row-3">
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Fecha</span>
                            </div>
                            <InputData
                              tabIndex={8}
                              type="type-alpha"
                              size={0}
                              input={moment(
                                venta.date,
                                "YYYY-MM-DD HH:mm:ss",
                              ).format("DD/MM/YYYY HH:mm:ss")}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Estado</span>
                            </div>
                            <InputData
                              tabIndex={10}
                              type="type-alpha"
                              size={0}
                              input={venta.status.toUpperCase()}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Nº proforma</span>
                            </div>
                            <InputData
                              tabIndex={6}
                              type="type-alpha"
                              size={0}
                              input={venta.nOperation}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Teléfono</span>
                            </div>
                            <InputData
                              tabIndex={9}
                              type="type-phone"
                              size={1}
                              input={venta.phone}
                              onChange={onChangePhone}
                              inactive={false}
                            />
                          </div>
                        </div>
                        <div className="screen-row-3">
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Realizado por</span>
                            </div>
                            <Dropdown
                              id="sales-filter-realizado-por"
                              tabIndex={13}
                              optionList={agents}
                              size={1}
                              op={filterRealizadoPor.id}
                              onChange={onChangePerformedBy}
                              disabled={venta.status === "Venta" || expired}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Campaña</span>
                            </div>
                            <Dropdown
                              id="sales-filter-campaign"
                              tabIndex={15}
                              optionList={campaigns}
                              size={1}
                              op={filterCampaign.id}
                              onChange={onChangeFilterCampaign}
                              disabled={venta.status === "Venta" || expired}
                            />
                          </div>
                          <div className="screen-item sales-button-checks">
                            <ButtonCheck
                              text="Aceptado"
                              checked={venta.accepted === true}
                              enabled={venta.status !== "Venta" && !expired}
                              onClick={() => onAcceptSale(true)}
                            />
                            <ButtonCheck
                              text="Rechazado"
                              checked={venta.accepted === false}
                              enabled={venta.status !== "Venta" && !expired}
                              onClick={() => onAcceptSale(false)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="general-header-separator" />
                    <div className="general-header-buttons">
                      <ButtonIconV
                        text="Nuevo"
                        icon="/images/add-orange.svg"
                        onClick={() =>
                          onGoToScreen("proforma", {
                            saleId: -1,
                          })
                        }
                      />
                      <ButtonIconV
                        text="Cancelar"
                        icon="/images/cancel-orange.svg"
                        onClick={() => onGoToScreen("ventas", true)}
                      />
                    </div>
                  </div>
                </div>

                {/* VENTA */}

                <div className="patient-search-content store-search-content">
                  <div className="opt-table-title">
                    <span>Detalle de la factura proforma</span>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title">
                    <div className="sales-left">
                      {saleId !== -1 &&
                        venta.accepted !== false &&
                        venta.status !== "Venta" &&
                        !expired && (
                          <ButtonIconH
                            text="Pasar a venta"
                            onClick={sendToSaleStep1}
                            disabled={false}
                          />
                        )}
                      <ButtonIconH
                        text="Observaciones"
                        onClick={() => setShowObservationsPopup(true)}
                      />
                    </div>
                    <div className="sales-right">
                      <DropdownFilter
                        disabled={false}
                        optionList={[{ id: "excel", text: "Excel" }]}
                        op={"EXPORTAR COMO"}
                        selectedOptions={[]}
                        onChange={async (e) => {
                          if (e.id === "excel") {
                            await exportProformaReport(e.id);
                          }
                        }}
                      />
                      <DropdownFilter
                        disabled={false}
                        optionList={printDocumentOptions}
                        op={"IMPRIMIR"}
                        selectedOptions={[]}
                        onChange={(e) => {
                          if (e.id === "imp") {
                            setShowProformaPrintingPopup(true);
                          }
                        }}
                      />
                      <ButtonIconH
                        text="Email"
                        onClick={() => setShowPrintingSalePopup(true)}
                        disabled={saleId === -1}
                      />
                    </div>
                  </div>
                  <div className="screen-item sales-table sales-table-item">
                    <DataTable
                      columns={ventaColumns}
                      data={ventaLinesTable}
                      className="custom-datatable navtable"
                      noDataComponent={""}
                      onRowClicked={(row, event) => {}}
                      onditionalRowStyles={conditionalRowStyles}
                    />
                  </div>
                  {venta.status !== "Venta" && !expired && (
                    <div className="sales-view-more sales-view-more-options">
                      <ButtonIconH
                        text="Añadir desde cesta"
                        onClick={() => showPopupCart(true)}
                      />
                    </div>
                  )}
                </div>

                {/* DESGLOSE */}

                <div className="patient-search-content store-search-content">
                  <div className="opt-table-title">
                    <span>Desglose de la factura proforma</span>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title screen-row-total">
                    <div className="sales-right sale-total-summary">
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total dto.</span>
                        </div>
                        <InputData
                          tabIndex={19}
                          type="type-alpha"
                          size={0}
                          input={totalDtoF}
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total base</span>
                        </div>
                        <InputData
                          tabIndex={20}
                          type="type-alpha"
                          size={0}
                          input={totalBaseF}
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total IVA</span>
                        </div>
                        <InputData
                          tabIndex={21}
                          type="type-alpha"
                          size={0}
                          input={totalIVAF}
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals screen-item-totals-bold">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total</span>
                        </div>
                        <InputDataCurrency
                          tabIndex={22}
                          type="type-alpha"
                          size={0}
                          input={venta.total.toString()}
                          onChange={(e) => {}}
                          onBlur={onBlurTotal}
                          onEnter={onBlurTotal}
                          inactive={venta.status === "Venta" || expired}
                          extra="content-right"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title sale-total-summary">
                    <div className="sales-left sales-tables">
                      <div className="sales-notification">
                        <span>
                          ESTE DOCUMENTO TIENE UNA VALIDEZ DE{" "}
                          {opticConfig.diasValidezPrePro} DÍAS
                        </span>
                      </div>
                      <div className="sales-table-right">
                        <div className="sale-table-header sale-table-ivas">
                          <div>
                            <span>Base</span>
                          </div>
                          <div>
                            <span>% IVA</span>
                          </div>
                          <div>
                            <span>IVA</span>
                          </div>
                          <div>
                            <span>Total</span>
                          </div>
                        </div>
                        {venta.ivas.map((item) => {
                          return (
                            <SaleTableItemIVA
                              key={item.percIva}
                              base={item.base}
                              percIva={item.percIva}
                              iva={item.iva}
                              total={item.total}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title screen-row-accept-venta">
                    {saleId !== -1 && (
                      <ButtonIconH text="Eliminar" onClick={onRemove} />
                    )}
                    {venta.status !== "Venta" && !expired && (
                      <ButtonIconH text="Guardar" onClick={saveSale} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {address && (
          <div className="popup-container secondary popup-calendar-event custom-popup-container">
            <div className="popup-message">
              <div className="popup-calendario">
                <PopupTitle
                  title="Dirección"
                  onClose={() => showAddressPopup(false)}
                />
              </div>
              <div className="popup-calendar-body">
                <div className="popup-calendar-contenido">
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Dirección</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alphanum-ext"
                      size={0}
                      input={address.address}
                      onChange={onChangeAddress}
                      tabIndex={101}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Localidad</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alpha"
                      size={0}
                      input={address.city}
                      onChange={onChangeCity}
                      tabIndex={102}
                    />
                    <div className="label">CP</div>
                    <InputData
                      id="cp-address"
                      maxLength={5}
                      inactive={false}
                      type="type-cp"
                      size={0}
                      input={address.postalCode}
                      onChange={onChangePostalCode}
                      onMalformed={() => setErrorCP("cp-address")}
                      error={errorCP === "cp-address"}
                      tabIndex={103}
                      icon="/images/link.svg"
                      onClick={() =>
                        showPopupCPDialog(
                          true,
                          address.address,
                          address.city,
                          "personal",
                        )
                      }
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Provincia</div>
                    <Dropdown
                      tabIndex={104}
                      id="provincia"
                      disabled={false}
                      optionList={provinceOptions}
                      size={3}
                      op={address.province}
                      onChange={onChangeProvince}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                    <div className="popup-row-buttons">
                      <ButtonIconH text="Guardar" onClick={saveAddress} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {cartPopup && (
          <div className="popup-container popup-normal popup-carts-sales">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">Añadir desde cesta</div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={() => showPopupCart(false)}
                />
              </div>
              {cartPopup.length > 0 && (
                <div className="popup-body">
                  {cartPopup.map((cart, index) => {
                    return (
                      <CartItem
                        key={index}
                        patientCode={cart.patientCode}
                        patientNameLastName={cart.patientNameLastName}
                        patientPic={cart.patientPic}
                        cardType={cart.cardType}
                        total={cart.total}
                        selected={cart.selected}
                        onClickCartItem={() => onClickCartItem(index)}
                      />
                    );
                  })}
                </div>
              )}
              {cartPopup.length === 0 && (
                <div className="popup-body">
                  <div className="popup-body-no-message">
                    <span>No existen cestas pendientes de procesar.</span>
                  </div>
                </div>
              )}
              <div className="popup-footer">
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                  <div className="popup-row-buttons">
                    {cartPopup.length > 0 ? (
                      <ButtonIconH
                        text="Añadir a venta"
                        onClick={addCartToSale}
                      />
                    ) : (
                      <ButtonIconH
                        text="Cerrar"
                        onClick={() => showPopupCart(false)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {nifTypePopup !== "" && (
          <PopupNIFTypes
            idNif={venta.nifType}
            onClick={() => showNifTypePopup(false)}
            onAccept={(e) => acceptNifTypePopup(e.idNif)}
          />
        )}
        <PopupCP
          show={showPopupCP}
          direccion={cpPopupAddress}
          localidad={cpPopupCity}
          onAccept={(fullAddress) => onAcceptCP(fullAddress)}
          onCancel={() => showPopupCPDialog(false, "", "", "personal")}
        />
        <PopupSaleObservations
          show={showObservationsPopup}
          obs={venta.observations}
          onClose={() => setShowObservationsPopup(false)}
          onSave={(obs) => {
            const ventaN = structuredClone(venta);
            ventaN.observations = obs;
            setVenta(ventaN);
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
        <PopupInvoicePrintingSimple
          show={showProformaPrintingPopup}
          title="Imprimir factura proforma"
          endpoint="gestionDocumental/ImprimirProforma.php"
          params={{
            idProforma: saleId,
            maxDias: opticConfig.diasValidezPrePro,
          }}
          errorMessage="Error al generar proforma."
          onClose={() => setShowProformaPrintingPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
        <PopupPrintingSaleSimple
          show={showPrintingSalePopup}
          title="Imprimir factura proforma"
          endpoint="gestionDocumental/ImprimirProforma.php"
          buildParams={() => ({
            idProforma: saleId,
            maxDias: opticConfig.diasValidezPrePro,
          })}
          documentOptions={printDocumentOptions}
          errorMessage="Error al generar proforma."
          onClose={() => setShowPrintingSalePopup(false)}
          onSent={async (adjunto) => {
            setEmailAttachment(adjunto);
            const nombreDocumento = adjunto.titulo.replace(/\.[^/.]+$/, "");
            setEmailAsunto(
              ("Factura proforma " + nombreDocumento).toUpperCase(),
            );

            let email = "";
            if (venta.idPaciente && venta.idPaciente !== -1) {
              const response = await post("ObtenerDatosPaciente.php", {
                token: userData.token,
                optica: selectedOptic.id,
                idPaciente: venta.idPaciente,
              });
              email = response?.email ?? "";
            }
            setEmailDestinatario(email);

            setShowEmailPopup(true);
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
        <PopupEmail
          show={showEmailPopup}
          destinatario={emailDestinatario}
          asunto={emailAsunto}
          adjuntos={emailAttachment ? [emailAttachment] : []}
          onCancel={() => setShowEmailPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      </div>
    );
  },
);
